import '@mrhenry/wp--bugsnag-config';

/* Modules */
import './modules/input-sink.ts';
import './modules/mr-accordion.ts';
import './modules/mr-carousel.ts';
import './modules/mr-text-carousel.ts';
import './modules/navigation-overlay.ts';

import MrDeltaTime from '@mrhenry/wp--mr-delta-time';
customElements.define( 'mr-delta-time', MrDeltaTime );
